/** MA Ribbon lengths — match backend MA_RIBBON_FAST_LEN / MA_RIBBON_SLOW_LEN */
export const MA_RIBBON_FAST_LEN = 9;
export const MA_RIBBON_SLOW_LEN = 21;

/**
 * EMA series (ta-style): SMA seed at index period-1, then standard EMA.
 */
export function emaSeries(values, period) {
  const out = new Array(values.length).fill(null);
  if (!values.length || period < 1) return out;

  const mult = 2 / (period + 1);
  let ema = null;

  for (let i = 0; i < values.length; i++) {
    const v = values[i];
    if (!Number.isFinite(v)) {
      out[i] = null;
      continue;
    }
    if (i < period - 1) {
      out[i] = null;
      continue;
    }
    if (ema === null) {
      let sum = 0;
      for (let j = i - period + 1; j <= i; j++) {
        sum += values[j];
      }
      ema = sum / period;
    } else {
      ema = (v - ema) * mult + ema;
    }
    out[i] = ema;
  }
  return out;
}

/**
 * Build custom-series data points [{ time, fast, slow }] from chart candles.
 * @param {Array} candles - chart rows with close + time (unix seconds)
 * @param {(candle: object) => number|null} [timeFn] - optional time mapper
 */
export function buildMaRibbonDataFromCandles(candles, timeFn) {
  if (!Array.isArray(candles) || candles.length === 0) return [];

  const times = [];
  const closes = [];

  for (const candle of candles) {
    const time = timeFn ? timeFn(candle) : (typeof candle.time === 'number' ? candle.time : Number(candle.time));
    const close = parseFloat(candle.close);
    if (!Number.isFinite(time) || !Number.isFinite(close)) continue;
    times.push(time);
    closes.push(close);
  }

  if (closes.length === 0) return [];

  const fast = emaSeries(closes, MA_RIBBON_FAST_LEN);
  const slow = emaSeries(closes, MA_RIBBON_SLOW_LEN);
  const points = [];

  for (let i = 0; i < times.length; i++) {
    if (fast[i] == null || slow[i] == null) continue;
    points.push({ time: times[i], fast: fast[i], slow: slow[i] });
  }

  return points;
}

export function buildMaRibbonDataFromRows(rows) {
  return buildMaRibbonDataFromCandles(rows);
}
